export default __webpack_public_path__ + "static/media/logo.521bd32f.png";